import { resolveDashboardAction } from '@/modules/admin-v2/utils/resolveDashboardAction';
import type { DashboardInsight } from '@yawi/types';
import { Brain, TrendingDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface InsightHeroCardProps {
  data: DashboardInsight | null;
  loading?: boolean;
}

export function InsightHeroCard({ data, loading }: InsightHeroCardProps) {
  const navigate = useNavigate();

  if (loading) {
    return <div className="h-14 rounded-xl bg-white dark:bg-surface-secondary border-[0.5px] border-[#E8E6F8] dark:border-theme-light animate-pulse" />;
  }

  if (!data || data.type === 'none') return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 bg-white dark:bg-surface-secondary rounded-xl border-[0.5px] border-[#E8E6F8] dark:border-theme-light p-3.5">
      <div className="w-8 h-8 rounded-lg bg-[#F0EFF9] dark:bg-theme text-[#7F77DD] flex items-center justify-center flex-shrink-0">
        <Brain size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-medium text-[#1A1A18] dark:text-theme leading-tight">{data.headline}</p>
        {data.potentialLoss && (
          <p className="text-[11px] text-[#D64545] dark:text-red-400 flex items-center gap-1 mt-0.5">
            <TrendingDown size={12} />
            ${data.potentialLoss.amount.toLocaleString('es-MX')} {data.potentialLoss.label}
          </p>
        )}
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button
          onClick={() => navigate(resolveDashboardAction(data.primaryCta.action))}
          className="px-3 py-1.5 rounded-[20px] bg-[#1A1A18] dark:bg-primary-500 text-white text-[12px] font-medium hover:opacity-90 transition-opacity whitespace-nowrap"
        >
          {data.primaryCta.label}
        </button>
        {data.secondaryCta && (
          <button
            onClick={() => navigate(resolveDashboardAction(data.secondaryCta!.action))}
            className="px-3 py-1.5 rounded-[20px] border-[0.5px] border-[#E8E6F8] dark:border-theme-light text-[#1A1A18] dark:text-theme text-[12px] font-medium hover:bg-[#F8F7FF] dark:hover:bg-theme whitespace-nowrap"
          >
            {data.secondaryCta.label}
          </button>
        )}
      </div>
    </div>
  );
}
